<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('search.title') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('ReportManagement.search.Product Name') }}</label>
                        <InputText id="nameuser" :class="`${error.name ? 'p-invalid' : ''}`" type="text" :placeholder="$t('search.placeholder.search')" v-model="product_Name" />
                        <div class="text-red">{{ error.name }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('ReportManagement.search.Product Category') }}</label>
                        <InputText id="nameuser" :class="`${error.name ? 'p-invalid' : ''}`" type="text" :placeholder="$t('search.placeholder.search')" v-model="product_Type" />
                        <div class="text-red">{{ error.name }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('search.label.startDate') }}</label>
                        <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="start_Date" dateFormat="yy.mm.dd" :placeholder="$t('search.placeholder.date')"></Calendar>
                        <div class="text-red">{{ error.calendarValue }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="verify-pass">{{ $t('search.label.lastDate') }}</label>
                        <Calendar :class="`${error.calendarValue1 ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="end_Date" dateFormat="yy.mm.dd" :placeholder="$t('search.placeholder.date')"></Calendar>
                        <div class="text-red">{{ error.calendarValue1 }}</div>
                    </div>
                    <!-- <div class="p-field p-col-12 p-md-3">
                        <label for="s-state">Type</label>
                        <Dropdown id="s-state" v-model="contenttype" :options="contenttypes" optionLabel="name" placeholder="Select Content-Type"></Dropdown>
                    </div> -->
                </div>
                <!-- <div class="p-formgrid p-grid p-mb-3">
                    
                    
                </div> -->
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                        <!-- <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button> -->
                    </div>
                    <div>
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2" @click="searchuser"></Button>
                        <Button :label="$t('Reset')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('ReportManagement.list.Report List') }}</h5>
                    </div>
                    <div>
                        <!-- <Button label="Primary" class="p-mr-2 p-mb-2" @click="openBasic"><i class="pi pi-download p-mr-2"></i>{{ $t('button.downloadExcel') }}</Button> -->
                    </div>
                    <Dialog header="Please enter reason for download this file" v-model:visible="displayBasic" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '25vw' }">
                    <h5 style="margin-top:10px;">Enter Reason</h5>
                    <Textarea  v-model="downloadReason" rows="10" style="width:100%" maxlength="200" @input="Whenchange" />
                    <small style="color:gray">200 character maximum.</small>
                    <template #footer>
                        <Button label="Submit" icon="pi pi-check" @click="exceldownload" :disabled="IsDisable"  />
                        <Button label="Cancel" icon="pi pi-times" @click="closeBasic"  autofocus />
                    </template>
                </Dialog>
                </div>
                <DataTable :value="customer1" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" responsiveLayout="scroll">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty> No data found. </template>
                    <template #loading> Loading customers data. Please wait. </template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('#')" style="min-width: 12rem">
                        <template #body="{ index }">
                            <span class="p-column-title">Name</span>
                            {{ index + 1 }}
                        </template>
                    </Column>
                    <Column :header="$t('ReportManagement.list.Product Name')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Product Name</span>
                            {{ data.product_name }}
                        </template>
                    </Column>
                    <Column :header="$t('ReportManagement.list.Product Category')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Product Category</span>
                            {{ data.product_category }}
                        </template>
                    </Column>
                    <!-- <Column :header="$t('ReportManagement.list.Report')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Report</span>
                            {{ data.description }}
                        </template>
                    </Column> -->
                    <Column :header="$t('ReportManagement.list.Date & Time')" style="min-width: 12rem" :sortable="true">
                        <template #body="{ data }">
                            <span class="p-column-title">date&Time</span>
                            {{ formatDateTime(data.created_date) }}
                        </template>
                    </Column>
                    <Column :header="$t('Actions')">
                        <template #body="{ data }">
                            <span class="p-column-title">Actions</span>
                            <p style="display: none">{{ data.id }}</p>
                            <div style="display: flex">
                                <router-link :to="'/report_details/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <router-link :to="'/user/edit-user/' + data.id"
                                    ><Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2"><i class="pi pi-user-edit p-mr-2"></i> {{ $t('button.edit') }}</Button></router-link
                                > -->
                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import formatDateTime from '../../mixin/mixinFunction';
import ReportService from '../../service/API/ReportService';
import axios from 'axios';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    mixins: [formatDateTime],
    data() {
        return {
            downloadReason:'',
            IsDisable: true,
            displayBasic: false,
            product_Name: '',
            product_Type: '',
            start_Date: '',
            end_Date: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            customer1: null,
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            state: '',
            content: '',
            dropdownItem: null,
            error: {},
            username: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.reportService = new ReportService();
    },
    mounted() {
        const route = useRoute();
        console.log(route.params);
        this.listData();
    },
    watch: {},
    methods: {
        Whenchange(){
            if(this.downloadReason!=''){
                this.IsDisable=false;
            }else{
                this.IsDisable=true; 
            }
        },
        openBasic() {
            this.displayBasic = true;
        },
        closeBasic() {
            this.displayBasic = false;
        },
        exceldownload() {
            this.reportService.getExcel(this.product_Name, this.product_Type, this.start_Date, this.end_Date, this.username,this.downloadReason).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Reportlist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
                this.closeBasic();
            });
        },
        resetUser() {
            this.product_Name = '';
            this.product_Type = '';
            this.start_Date = '';
            this.end_Date = '';
            this.username = '';
            this.listData();
        },
        listData() {
            this.reportService.getReportList(this.product_Name, this.product_Type, this.start_Date, this.end_Date, this.username).then((data) => {
                this.customer1 = data.reportData;
                console.log(data);
                this.loading1 = false;
                this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
            });
        },
        searchuser() {
            if (this.product_Name == '' && this.product_Type == '' && this.start_Date == '' && this.end_Date == '') {
                this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                this.listData();
            }
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_Date = utc;
            this.end_Date = utc;
            this.listData();
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_Date = startDate;
            this.end_Date = endDate;
            this.listData();
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_Date = startDate;
            this.end_Date = endDate;
            this.listData();
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_Date = startDate;
            this.end_Date = endDate;
            this.listData();
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }
            return total;
        },
        confirm(id) {
            let self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'delete', url: `/receipt/report_registration/${id}` }).then(function (response) {
                        console.log(response);
                    });
                    self.reportService
                        .getReportList(self.product_Name, self.product_Type, self.start_Date, self.end_Date)
                        .then((data) => {
                            self.customer1 = data.reportData;
                            console.log(data);
                            self.loading1 = false;
                            self.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                        })
                        .catch((err) => {
                            if (err.response.data.statusCode == '401') {
                                localStorage.removeItem('token');
                                window.location.href = '/login';
                            }
                        });
                    this.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
</style>
